import { SEARCH_CITIES, SEARCH_QUERY } from "../../../../Utils/AllPagesQuriesAndMutations";

export let data = [
  {
    id: Math.random() * 10,
    name: "Load_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Loading_Name",
        label: "From Location",
        masterName: "GoogleLocation",
        type: "GoogleSearch",
        notSearchable: true,
        dropdowncontent: SEARCH_QUERY,
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "currentLocationRadius",
        label: "From Radius",
        type: "inputdrop",
        dropdowncontent: [50, 75, 100, 150, 200, 300],
        // isRequired: true,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Name",
        label: "To Location",
        masterName: "GoogleLocation",
        type: "GoogleSearch",
        notSearchable: true,
        dropdowncontent: SEARCH_QUERY,
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "destLocationRadius",
        label: "To Radius",
        type: "inputdrop",
        dropdowncontent: [50, 75, 100, 150, 200, 300],
        // isRequired: true,
        notSearchable: true,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Load_Details",
    label: "Load Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Load_Type",
        label: "Load Type",
        placeholder: "Load Live Duration",
        type: "inputdrop",
        autoComplete: "off",
        // isRequired: true,
        isSearchable: true,
        dropdowncontent: ["PTL", "FTL"],
      },
      {
        id: Math.random() * 10,
        name: "Min_Weight",
        label: "Min Weight (MT)",
        type: "number",
        // isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Max_Weight",
        label: "Max Weight (MT)",
        type: "number",
        // isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "ODC",
        label: "ODC",
        type: "inputdrop",
        dropdowncontent: ["Yes", "No"],
        min: 1,
        max: Infinity,
        // isRequired: false,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "loadPostAge",
        label: "Load Post Age",
        type: "number",
        // isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "startDate",
        label: "Loading_Date (From)",
        type: "Date",
        // isRequired: true,
        validate_key: "Date_Feature",
        // restrictDateRange: true,
      },
      {
        id: Math.random() * 10,
        name: "endDate",
        label: "Loading_Date (To)",
        type: "Date",
        // isRequired: true,
        validate_key: "Date_Feature",
        // restrictDateRange: true,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Vehicle_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Vehicle_Category",
        type: "inputdrop",
        dropdowncontent: [
          "Trailer Dala Body",
          "Trailer Flat Bed ",
          "Open Body Truck",
          "Container",
          "Tanker",
          "Tipper",
          "Bulker",
          "Dumper",
        ],
        min: 1,
        max: Infinity,
        notSearchable: true,
      },
    ],
  },
];
